<div *ngIf="meeting">
  <button
    class="bg-light border border-neutral-200 rounded p-[11px] mobile:mb-7 tablet:mb-9 hover:bg-neutral-50 active:bg-neutral-200"
    title="Back to dashboard"
    (click)="back()">
    <img src="https://postingpanda.blob.core.windows.net/clientpublicassets/global/content/img/icons/arrow_back.svg">
  </button>

  <div class="text-neutral-500 text-2 font-medium uppercase mb-4 leading-13 tracking-[1.04px]">
    Interview details
  </div>
  <div class="flex justify-between">
    <div class="text-dark text-7 font-medium leading-30">{{dashboardInfo?.jobTitle}}</div>
  </div>

  <div class="border-1 border-success-400 mobile:mt-7 tablet:mt-[44px] bg-success-50 py-[18px] px-6 rounded-base">
    <div class="flex gap-4">
      <img class="h-24"src="https://postingpanda.blob.core.windows.net/clientpublicassets/global/content/img/icons/generatesuccess.svg">
      <div>
        <span class="text-4 text-dark leading-24 block font-medium">You have successfully confirmed your interview! </span>
        <span class="text-4 text-dark leading-24 block">Your interview details can be found below or in your Interview Dashboard. You may now close this window, or return to your Interview Dashboard by <a (click)="back()" class="text-info-200 text-4 leading-24 cursor-pointer hover:underline">clicking here</a>.</span>
      </div>
    </div>
  </div>

  <div class="bg-light rounded border-l-6 shadow-mdlight mobile:p-6 tablet:p-8 w-full mobile:mt-7 tablet:mt-[44px] border-info-200">
    <div class="tablet:flex tablet:justify-between">
      <div>
        <!-- Interview Stage -->
        <div class="flex gap-2 mb-4">
          <img class="h-20" src="https://postingpanda.blob.core.windows.net/clientpublicassets/global/content/img/svg/briefcase.svg" alt="Interview Stage">
          <span class="text-4 text-dark leading-24">{{meeting.meetingTitle}}</span>
        </div>
        <!-- Date  -->
        <div class="mb-4">
          <interview-date-widget
            [meeting]="meeting"
          ></interview-date-widget>
        </div>
        <!-- Time -->
        <div class="mb-4">
          <interview-time-widget
            [meeting]="meeting"
          ></interview-time-widget>
        </div>
        <!-- Location  -->
        <interview-location-widget
        [meeting]="meeting"
        [dashboardInfo]="dashboardInfo"
      ></interview-location-widget>

    </div>
    <div class="flex tablet:items-start gap-2 mobile:mt-7 tablet:mt-0">
      <button
        class="mobile:w-full tablet:w-auto hover:bg-neutral-50 active:bg-neutral-200 text-center whitespace-nowrap inline-block py-4 px-6 bg-light border border-neutral-200 text-[14px] rounded-base leading-18"
        (click)="addToCalendar(meeting.id)">
        <span class="flex items-center gap-2 justify-center">
            <img class="h-[18px]" src="https://postingpanda.blob.core.windows.net/clientpublicassets/global/content/img/icons/calendar-add.svg">
            <span>Add to Calendar</span>
        </span>
      </button>

      <a
        *ngIf="meeting.interviewType == InterviewType.REMOTE && meeting.location?.remoteUrl && isJoinButtonEnabled(meeting) && meeting.status === InterviewStatus.ACCEPTED"
        [href]="meeting.location!.remoteUrl"
        target="_blank"
        class="mobile:w-full tablet:w-[inherit] hover:bg-neutral-50 active:bg-neutral-200 disabled:border-neutral-100 disabled:cursor-not-allowed disabled:text-neutral-300 text-center whitespace-nowrap inline-block py-4 px-6 border border-neutral-200 text-[14px] text-neutral-600 rounded-base leading-18">
        Join Interview
      </a>
      <button
        type="button"
        *ngIf="meeting.interviewType == InterviewType.REMOTE && meeting.location?.remoteUrl && !isJoinButtonEnabled(meeting) && meeting.status === InterviewStatus.ACCEPTED"
        disabled
        class="mobile:w-full tablet:w-[inherit] hover:bg-neutral-50 active:bg-neutral-200 disabled:border-neutral-100 disabled:cursor-not-allowed disabled:text-neutral-300 text-center whitespace-nowrap inline-block py-4 px-6 border border-neutral-200 text-[14px] text-neutral-600 rounded-base leading-18 tooltip-subject">
        Join Interview
        <div class="tooltip whitespace-pre-line w-[200px] bottom-11 mobile:left-[-30px] tablet:left-[-40px]">
          <div class="tooltip-content text-left text-3 leading-20">
            This button will become active closer to your scheduled interview time. Please check back on the day of your interview.
          </div>
        </div>
      </button>
    </div>
  </div>

  <hr class="my-7 text-neutral-100" />

  <div *ngIf="interviewers && interviewers.length">
    <div class="text-neutral-500">Interviewers</div>
    <div *ngFor="let interviewer of interviewers; let last = last" class="">
      <div class="flex py-5">
        <div class="flex items-center gap-5">
          <span [style.background]="interviewer.avatarColour.backgroundColour" class="w-32 h-32 flex items-center justify-center rounded-full">
            <p class="font-medium text-center"[style.color]="interviewer.avatarColour.textColour">
              {{getInitials(interviewer)}}
            </p>
          </span>
          <span>
            <p class="text-4 text-dark leading-24">{{interviewer.firstName}} {{interviewer.lastName}}</p>
            <p class="text-4 text-neutral-500 leading-24" *ngIf="interviewer.jobTitle">{{interviewer.jobTitle}}</p>
          </span>
        </div>
      </div>
      <hr class="ml-10 text-neutral-100" *ngIf="!last" />
    </div>
  </div>

  <interview-location-map-widget
    [meeting]="meeting"
  ></interview-location-map-widget>
</div>

  <decline-interview-widget
    *ngIf="!meetingInThePast(meeting)"
    [meeting]="meeting"
    (onDeclineInterviewClicked)="declineInterview($event)">
  </decline-interview-widget>